import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
const KEY = "tp_basket";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const lineKey = (it) => it.item_id + (it.workshop_ids ? ":" + [...it.workshop_ids].sort().join(",") : "");

  const add = useCallback((item) => {
    const key = lineKey(item);
    let dup = false;
    setItems((prev) => {
      if (prev.some((p) => lineKey(p) === key)) { dup = true; return prev; }
      return [...prev, { ...item, key }];
    });
    setTimeout(() => {
      if (dup) toast.info(`${item.name} is already in your basket`, { action: { label: "View basket", onClick: () => setOpen(true) } });
      else toast.success(`${item.name} added to basket`, { action: { label: "View basket", onClick: () => setOpen(true) } });
    }, 0);
  }, []);

  const remove = useCallback((key) => setItems((prev) => prev.filter((p) => p.key !== key)), []);
  const clear = useCallback(() => setItems([]), []);
  const total = items.reduce((s, i) => s + i.price, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, total, count: items.length, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};
